import { useAppSelector } from "@/common/hooks";

export const useHealthSystems = () => {
  return useAppSelector((state) => state.appConfig.healthSystem.healthSystems);
};

export const useHealthSystemById = () => {
  return useAppSelector((state) => state.appConfig.healthSystem.healthSystemById);
};
